import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-oem-inventory",
  "use": "icon-oem-inventory-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-oem-inventory\"><path d=\"M162.86,190.56H57.14a14.52,14.52,0,0,1-14.5-14.5V77.55h9v98.51a5.5,5.5,0,0,0,5.5,5.5H162.86a5.5,5.5,0,0,0,5.5-5.5V77.55h9v98.51A14.52,14.52,0,0,1,162.86,190.56Z\" /><polygon points=\"23.92 95.87 18.98 88.35 110 28.55 201.02 88.35 196.08 95.87 110 39.32 23.92 95.87\" /><path d=\"M145.22,150.86H74.78l35.22-61Zm-54.86-9h39.28l-19.64-34Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol